import {useQuery} from "react-query";
import {useRecoilValue} from "recoil";
import api from "../services/api";
import accessTokenState from "../state/accessTokenState";
import {useEffect} from "react";
import firebaseApp from "../services/firebase";

export const fetchUser = () => {
    return api.get('users/self').then((response) => response?.data?.data);
}

const useFetchUser = (options = {}) => {
    const accessToken = useRecoilValue(accessTokenState);
    
    const query = useQuery('user', fetchUser, {
        enabled: !!accessToken && (typeof options.enabled === 'undefined' || options.enabled),
    });

    useEffect(() => {
        firebaseApp.analytics().setUserId(query.data?.id);

        return () => {
            firebaseApp.analytics().setUserId(null);
        };
    }, [query.data?.id]);

    return query;
};

export default useFetchUser;
